<template>
    <notifications
        :group="group"
        position="bottom right"
        :close-on-click="false"
        class="warning-notifications ma-4"
        style="width: 400px;"
    >
        <template slot="body" slot-scope="props">
            <v-card elevation="0" style="width: 400px; border-left: solid 4px #ff5252;">
                <v-row class="pa-2">
                    <v-col cols="2" class="align-self-center ml-2">
                        <img :src="icons.info" width="40" />
                    </v-col>
                    <v-col class="align-self-center notification-text">
                        <p>
                            {{ $t("pay.notification_text") }}
                        </p>
                        <a @click="addCreditCard()">{{ $t("pay.add") }}</a>
                    </v-col>
                </v-row>
            </v-card>
        </template>
    </notifications>
</template>

<script>
import info from "@/assets/img/no-cc.png";

export default {
    name: "NoCreditCardNotification",
    props: ["group"],
    data() {
        return {
            icons: { info },
        };
    },
    methods: {
        addCreditCard() {
            this.$store.dispatch("OPEN_PAYMENTS_MODAL", true);
        },
    },
};
</script>

<style scoped>
.notification-text p {
    color: #666666;
    font-size: 13px;
}
.notification-text a {
    font-size: 13px;
    text-decoration: underline;
}
</style>
